export default __webpack_public_path__ + "static/media/pierre-chatel-innocenti-AlSlE8IAjZo-unsplash 1.19fbd52b.png";